import { KuposCommonLoader, MonthYearPicker } from '../../../common';
import React, { useEffect, useState } from 'react';

import ApiUrls from '../../../../services/apiUrls';
// import ApiUrls from '../../../services/apiUrls';
import BodyItem from './components/BodyItem';
import CommonService from '../../../../services/commonService';

function MainTabsBodyMyPromotions(props) {
  let date = new Date();

  const [details, setDetails] = useState([
    {
      amount: '$3.000',
      color: 'secondary-text',
      triangle: 'secondary-up-triangle',
      credit: 'Ragalo en creditos',
      creditDate: '29 de junio de 2019',
      expiry: 'Vence el',
      expiryDate: '29/06/2019',
    },
    {
      amount: '$3.000',
      color: 'secondary-text',
      triangle: 'secondary-up-triangle',
      credit: 'Ragalo en creditos',
      creditDate: '20 de junio de 2019',
      expiry: 'Vence el',
      expiryDate: '20/06/2019',
    },
    {
      amount: '$3.000',
      color: 'grey-text',
      triangle: 'grey-up-triangle',
      credit: 'Ragalo en creditos',
      creditDate: '16 de junio de 2019',
      expiry: 'Vencido el',
      expiryDate: '16/06/2019',
    },
    {
      amount: '$2.000',
      color: 'primary-text',
      triangle: 'primary-down-triangle',
      credit: 'Ragalo utilizados en comparo',
      creditDate: '30 de may de 2019',
      expiry: 'Utilizado el',
      expiryDate: '30/05/2019',
    },
    {
      amount: '$2.000',
      color: 'grey-text',
      triangle: 'grey-up-triangle',
      credit: 'Ragalo en creditos',
      creditDate: '30 de may de 2019',
      expiry: 'Vencido el',
      expiryDate: '30/05/2019',
    },
  ]);
  const [selectedYear, setSelectedYear] = useState(date.getFullYear());
  const [selectedMonth, setSelectedMonth] = useState(date.getMonth());

  const loadVirtualMoney = (month, year) => {
    props.actions.getVirtualMoney({ url: ApiUrls.myVirtualMoney(month + 1 + '-' + year) });
  };

  const loadTransactions = (month, year) => {
    let operator = JSON.parse(localStorage.getItem('metaData') || '{}');
    let operatorId =
      operator &&
      operator.operator_sites &&
      operator.operator_sites.operator.operator_id &&
      operator.operator_sites.operator.operator_id;

    let operator_id =
      props.operator && props.operator.operator_id ? props.operator.operator_id : operatorId;
    props.actions.getMyTransactions({
      url: ApiUrls.myTransactions(month + 1 + '-' + year, operator_id),
    });
  };

  useEffect(() => {
    loadVirtualMoney(selectedMonth, selectedYear);
    loadTransactions(selectedMonth, selectedYear);
  }, []);

  const onMonthChange = (maskedValue, selectedYear, selectedMonth) => {
    setSelectedYear(selectedYear);
    setSelectedMonth(selectedMonth);

    loadVirtualMoney(selectedMonth, selectedYear);
    loadTransactions(selectedMonth, selectedYear);
  };

  const { t } = props;
  return (
    <div className="sub-section-description scroll-style my-account-main-tabs-body-my-promotions">
      <div className="recharge-wallet-top-strip">
        <div className="back-button-format-my-account" onClick={() => props.onMenuChange()}>
          <img
            className="back-button-format-my-account"
            className="qr-back"
            src="/static/images/back_arrow_bip.png"
          />
        </div>
        <div>
          <div className="sub-section-description-title">
            <span className="bold-text font14">{t('PROFILE.PROMOTIONS')}</span>
          </div>
          <div className="sub-section-description-description font11">
            <span>{t('PROFILE.PROMOTIONS_DESCRIPTION')}</span>
          </div>
        </div>
        <div></div>
      </div>

      <div className="balance">
        <div className="movements-in-capsule-menu font10">
          <MonthYearPicker
            selectedYear={selectedYear}
            selectedMonth={selectedMonth}
            operator={props.operator}
            onMonthChange={onMonthChange}
          ></MonthYearPicker>
        </div>
        <div className="promo-balance">
          <div className="bold-text">
            <span className="font14" style={{ color: '#9ACD32' }}>
              {props.data.loginData && props.data.loginData.balances
                ? CommonService.currency(props.data.loginData.balances.clp.credit).split(',')[0]
                : '$ 0'}
            </span>
          </div>

          <div className="text-centre">
            <span className="font12">{t('PROFILE.CREDIT_BALANCE')}</span>
          </div>
          <div className="clearfix"></div>
        </div>
        <div className="clearfix"></div>
      </div>
      <div className="sub-section-body">
        {props.data.getVirtualMoneyPending ? (
          <div className="my-trips-loader">
            <KuposCommonLoader />
          </div>
        ) : null}

        {props.data &&
        props.data.myVirtualMoney &&
        props.data.myTransactions &&
        !props.data.myVirtualMoney.error &&
        !props.data.myTransactions.error
          ? [...props.data.myVirtualMoney, ...props.data.myTransactions]
              .filter(item => item.wallet_type === 'Credit' || item.wallet_type === 'WalletCredit')
              .map((val, key) => <BodyItem val={val} key={key} t={props.t} />)
          : null}
        {props.data &&
        props.data.getVirtualMoneyError &&
        props.data.getVirtualMoneyError.data &&
        props.data.getVirtualMoneyError.data.error ? (
          <div className="trips-error-msg">
            <span>{props.data.getVirtualMoneyError.data.error}</span>
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default MainTabsBodyMyPromotions;



// WEBPACK FOOTER //
// ./src/features/themes/my-account/MainTabsBodyMyPromotions/MainTabsBodyMyPromotions.js